<template>
    <g-modal
        :visible="visible"
        :closable="true"
        :mask-closable="true"
        :destroy-on-close="true"
        :autofocus="true"
        :get-container="() => $parent.$el"
        centered
        @cancel="handleClose"
    >
        <g-typography tag="p" class="mt-20">{{ tooltip }}</g-typography>
        <template #footer>
            <g-button
                class="button"
                theme="basic"
                type="primary"
                :class="[{ 'is-loading': loading }]"
                @click="handleConfirm"
            >
                Okay
            </g-button>
        </template>
    </g-modal>
</template>

<script>
    export default {
        name: 'AgentTooltipModal',

        props: {
            visible: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            tooltip: {
                type: String,
                default: ''
            }
        },
        setup(props, { emit }) {
            const handleClose = () => {
                emit('modal-close');
            };
            const handleConfirm = () => {
                emit('modal-confirm');
            };
            return {
                handleClose,
                handleConfirm
            };
        }
    };
</script>
